import React from "react";
import Box from "@mui/material/Box";

import {DeskingPage} from "../DeskingPage/DeskingPage";
import {DeskingContextProvider} from "../../contexts/DeskingContext";
import {BaseModal} from "../../components/BaseModal";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";


export const DeskingModal = ( { id, isOpen, setIsOpen, ...props } ) => {
    return (
        <BaseModal
            isOpen={isOpen}
            setIsOpen={setIsOpen}
        >
            <Box className={'DeskingModal'}>
                <DeskingContextProvider {...props}>
                    <DeskingPage
                        id={id}
                        isOpen={isOpen}
                        setIsOpen={setIsOpen}
                        {...props}
                    />
                </DeskingContextProvider>
            </Box>
        </BaseModal>
    )
}